import { userAPI } from "../UserAPI";

/**
 * @param {{resource: any, stableKey?: string}} props
 */
export const LinkResource = ({ resource, stableKey: _stableKey }) => {
    // Handle URL construction - if URL is already absolute, use it as is, otherwise use getResourceURL
    const linkUrl = resource.url && resource.url.startsWith('http') 
        ? resource.url 
        : userAPI.getResourceURL(resource.url || '');
    
    return <div className="box-border w-full">
        <a className={'link'} href={linkUrl}>{resource.text}</a>
    </div >
}
